import React from "react";
import { Spinner } from "react-bootstrap";

const AuthWrapper = ({ auth, children }) => {
  return (
    <>
      {auth === true ? (
        <>{children}</>
      ) : (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "50vh" }}
        >
          <Spinner animation="grow" variant="dark" />
        </div>
      )}
    </>
  );
};

export default AuthWrapper;
